import focusPlugin from "@alpinejs/focus";
import Alpine from "alpinejs";
import "@github/clipboard-copy-element";
import "@rezstream/ui";
import "./behaviors";
// Dark mode is experimental, but this will let you enable it if you want
if (localStorage.getItem("theme") === "dark") {
    document.documentElement.classList.add("dark");
}
globalThis.Alpine = Alpine;
Alpine.plugin(focusPlugin);
Alpine.start();
